import axios, { AxiosPromise } from 'axios';

const apiSetUrlInSession = 'api/login-session'

export default class LoginService {
  
  public async login(loc = window.location) {    
    const port = loc.port ? ':' + loc.port : '';
    let contextPath = location.pathname;
    if (contextPath.endsWith('accessdenied')) {
      contextPath = contextPath.substring(0, contextPath.indexOf('accessdenied'));
    }
    if (!contextPath.endsWith('/')) {
      contextPath = contextPath + '/';
    }

    await this.saveUrlInSession(location.pathname)

 	  loc.href = `//${loc.hostname}${port}/oauth2/authorization/oidc`;
  }

  public logout(): AxiosPromise<any> {
	//alert("U logout");
    return axios.post('api/logout');
  }

  public saveUrlInSession(url: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
      .get(`${apiSetUrlInSession}?url=${encodeURIComponent(url)}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
    });  
  }
}
